<script setup>
import { FIELDS, calcZValue, soleLengthToRange } from '@nineteen-2/dtc-din'
import { computed, defineProps, ref, watch } from "vue";
import dayjs from "dayjs";
import { getFieldsFromFieldGroup } from "@/components/frontend/form-components/din.js";
import { BookAlertIcon } from "@lucide/vue";

const props = defineProps({
  field: { type : Object},
  registration: { type : Object},
})

const getAge = function (date) {
  if (!date) {
    return null;
  }
  const today = dayjs(new Date());
  return today.diff(date, 'year') // 7
}

const fields = computed(() => getFieldsFromFieldGroup(props.field))

const din = computed(() => {
  let din = null;

  if (!props.field || !props.registration) {
    return din;
  }

  if (
    props.registration?.[fields.value[FIELDS.SKIER_WEIGHT]?.key]
    && props.registration?.[fields.value[FIELDS.SKIER_HEIGHT]?.key]
    && props.registration?.[fields.value[FIELDS.SKIER_TYPE]?.key]
    && props.registration?.[fields.value[FIELDS.SKIER_SOLE_LENGTH]?.key]
    && props.registration.birthday
  ) {
    din = calcZValue(
      props.registration[fields.value[FIELDS.SKIER_WEIGHT]?.key],
      props.registration[fields.value[FIELDS.SKIER_HEIGHT]?.key],
      props.registration[fields.value[FIELDS.SKIER_TYPE]?.key],
      soleLengthToRange(props.registration[fields.value[FIELDS.SKIER_SOLE_LENGTH]?.key]),
      getAge(props.registration.birthday),
    )
  }

  return !!din ? String(din) : null;
})

const emits = defineEmits(['dinUpdated'])

watch(din, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    emits('dinUpdated', {
      [fields.value[FIELDS.RECOMMENDED].key] : newVal
    })
  }

  if (! dinTouched.value || ! dinSelected.value) {
    dinSelected.value = newVal
  }
})

const dinTouched = ref(false);
const dinSelected = ref(null);
watch(dinSelected, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    emits('dinUpdated', {
      [fields.value[FIELDS.SELECTED].key] : newVal
    })
  }
})

</script>
<template>
  <div v-if="props?.field" class="row">
    <div class="form-group col-md-6">
      <label :for="'registration_' + fields[FIELDS.RECOMMENDED].key">
        {{ fields[FIELDS.RECOMMENDED].templateOptions.label }}
        <small v-if="fields[FIELDS.RECOMMENDED].templateOptions.required" class="align-middle font-weight-bold text-danger">*</small>
      </label>
      <input :type="fields[FIELDS.RECOMMENDED]?.templateOptions?.type ?? 'text'"
             :id="'registration_' + fields[FIELDS.RECOMMENDED].key"
             :value="din"
             :class="[
                           'form-control',
                         ]"
             readonly />
    </div>

    <div class="form-group col-md-6">
      <label :for="'registration_' + fields[FIELDS.SELECTED].key">
        {{ fields[FIELDS.SELECTED].templateOptions.label }}
        <small v-if="fields[FIELDS.SELECTED].templateOptions.required" class="align-middle font-weight-bold text-danger">*</small>
      </label>
      <input :type="fields[FIELDS.SELECTED]?.templateOptions?.type ?? 'text'"
             :id="'registration_' + fields[FIELDS.SELECTED].key"
             :value="dinSelected"
             @focus="dinTouched = true"
             @input="dinSelected = $event.target.value"
             min="0.75"
             max="30"
             step="0.25"
             :class="[
                             'form-control',
                           ]"
             />
    </div>
    <div class="col"
         v-if="fields[FIELDS.SELECTED].templateOptions.tooltip && dinSelected !== din"
    >
      <span class="text-danger">
        <BookAlertIcon/> {{ fields[FIELDS.SELECTED].templateOptions.tooltip }}
      </span>
    </div>
  </div>
</template>